import { render, staticRenderFns } from "./DocumentDetailList32.vue?vue&type=template&id=b2f4daca&scoped=true"
import script from "./DocumentDetailList32.vue?vue&type=script&lang=js"
export * from "./DocumentDetailList32.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f4daca",
  null
  
)

export default component.exports